import { fromJS } from 'immutable';

export default value => {
  const keys = Object.keys(value);

  const initialState = keys
    .map(x => ({name: x, value: value[x](undefined, {})}))
    .reduce((map, x) => map.set(x.name, x.value), fromJS({}));

  return (state = initialState, action) => keys
    .map(x => ({name: x, value: value[x](state.get(x), action)}))
    .reduce((map, x) => map.set(x.name, x.value), state);
};



// WEBPACK FOOTER //
// ./src/utilities/combineReducers.js